import { render, staticRenderFns } from "./Bonuses.vue?vue&type=template&id=84aedc3c&scoped=true"
import script from "./Bonuses.vue?vue&type=script&lang=js"
export * from "./Bonuses.vue?vue&type=script&lang=js"
import style0 from "./Bonuses.vue?vue&type=style&index=0&id=84aedc3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aedc3c",
  null
  
)

export default component.exports